import client from './client';

export const getMemberships = (params) => client.get('/memberships', { params });

export const getUserMembership = (userId) => client.get(`/memberships/user/${userId}`);

export const adjustMembership = (userId, data) => client.post(`/memberships/user/${userId}/adjust`, data);

export const getRebatePolicy = () => client.get('/memberships/rebate-policy');

export const updateRebatePolicy = (data) => client.put('/memberships/rebate-policy', data);

export const getMembershipPlanPolicy = () => client.get('/memberships/plan-policy');

export const updateMembershipPlanPolicy = (data) => client.put('/memberships/plan-policy', data);

export const getAiGuidePolicy = () => client.get('/memberships/ai-guide-policy');

export const updateAiGuidePolicy = (data) => client.put('/memberships/ai-guide-policy', data);

export const getPriceMonitorPolicy = () => client.get('/memberships/price-monitor-policy');

export const updatePriceMonitorPolicy = (data) => client.put('/memberships/price-monitor-policy', data);
